<div class="first mb-5" *ngIf="candidate">
    <div class="header">
        <h4>{{ candidate?.candidate_first_name }} {{
            candidate?.candidate_last_name }}</h4>
    </div>
    <div class="content">
        <div class="row mb-5">
            <div class="d-flex justify-content-center align-items-center mt-5 w-100">
           
            <div
                class="h-10px mx-3 width-progress bg-light-success rounded">
                <div class="bg-success rounded h-8px"
                    role="progressbar"
                    [style.width.%]="candidate?.user_final_score"
                    aria-valuenow="50" aria-valuemin="0"
                    aria-valuemax="100"></div>
            </div>
            <div
            class="mt-auto">
            <span class="progress-value">{{
                candidate?.user_final_score }}%</span>
        </div>
        </div>
        </div>
        <div class="table-responsive">

            <div class="table-wrapper">

                <table class="table skills back" *ngIf="candidate?.skill?.length > 0">
                    <thead>
                      <tr>
                        <th class="min-w-100px">Skills</th>
                        <th class="min-w-75px">Notation</th>
                        <th class="min-w-75px">Coeff</th>
                        <th class="min-w-75px">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let skill of candidate?.skill">
                        <td>
                          <span class="style skill-badge">{{ skill?.skill }}</span>
                        </td>
                        <td>{{ skill?.star_coef }}</td>
                        <td>{{ skill?.coef }}</td>
                        <td>
                          <span [ngClass]="{
                            'red': skill?.user_score_skill >= 0 && skill?.user_score_skill < 20,
                            'light-orange': skill?.user_score_skill >= 20 && skill?.user_score_skill < 40,
                            'fancy-orange': skill?.user_score_skill >= 40 && skill?.user_score_skill < 80,
                            'green': skill?.user_score_skill >= 80
                          }">{{ skill?.user_score_skill }}</span>
                        </td>
                      </tr>
                    </tbody>
                </table>

                <table class="table skills back2" *ngIf="candidate?.language?.length > 0">
                  <thead>
                    <tr>
                      <th>Langues</th>
                      <th>Notation</th>
                      <th>Coeff</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let language of candidate?.language">
                      <td>
                        <span class="style skill-badge">{{ language?.language }}</span>
                      </td>
                      <td>{{ language?.star_coef }}</td>
                      <td>{{ language?.coef }}</td>
                      <td>
                        <span [ngClass]="{
                            'red': language?.user_score_language >= 0.00 && language?.user_score_language < 20.00,
                            'light-orange': language?.user_score_language >= 20.00 && language?.user_score_language < 40.00,
                            'fancy-orange': language?.user_score_language >= 40.00 && language?.user_score_language < 80.00,
                            'green': language?.user_score_language >= 80.00
                        }">
                            {{ language?.user_score_language }}
                        </span> 
                    </tr>
                  </tbody>
                </table>
              
                <table class="table skills back" *ngIf="candidate?.availability != null">
                  <thead>
                    <tr>
                      <th>Disponibilité</th>
                      <th></th> <!-- Empty column for alignment -->
                      <th>Coeff</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf=" candidate?.availability != null  && candidate.availability?.length > 0; else noAvailability">
                    <tr *ngFor="let availab of candidate?.availability">
                      <td>
                        <span class="style skill-badge">
                          {{ getAvailabilityLabel(availab?.availability) }}
                        </span>
                      </td>
                      <td></td> <!-- Empty cell for alignment -->
                      <td>{{ availab?.coef }}</td>
                      <td>
                        <span [ngClass]="{
                            'red': availab?.user_score_availability >= 0.00 && availab?.user_score_availability < 20.00,
                            'light-orange': availab?.user_score_availability >= 20.00 && availab?.user_score_availability < 40.00,
                            'fancy-orange': availab?.user_score_availability >= 40.00 && availab?.user_score_availability < 80.00,
                            'green': availab?.user_score_availability >= 80.00
                        }">
                            {{ availab?.user_score_availability }}
                        </span>  
                      </td>
                     </tr>
                  </ng-container>
                  <!-- Message when qcm_score is not available -->
                  <ng-template #noAvailability>
                    <tr>
                      <td colspan="4" class="text-danger">{{ candidate?.availability?.message }}</td>
                    </tr>
                  </ng-template>
                  </tbody>
                </table>

                <table class="table skills back2" *ngIf="candidate?.experience?.length > 0">
                    <thead>
                      <tr>
                        <th class="min-w-100px">Année d’expérience</th>
                        <th></th> <!-- Empty column for alignment -->
                        <th class="min-w-75px">Coeff</th>
                        <th class="min-w-75px">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let exp of candidate?.experience">
                        <td>
                          <span class="style skill-badge">{{ exp?.year }} ans</span>
                        </td>
                        <td></td> <!-- Empty cell for alignment -->
                        <td>{{ exp?.coef }}</td>
                        <td>
                          <span [ngClass]="{
                            'red': exp?.user_score_experience >= 0.00 && exp?.user_score_experience < 20.00,
                            'light-orange': exp?.user_score_experience >= 20.00 && exp?.user_score_experience < 40.00,
                            'fancy-orange': exp?.user_score_experience >= 40.00 && exp?.user_score_experience < 80.00,
                            'green': exp?.user_score_experience >= 80.00
                          }">
                            {{ exp?.user_score_experience }}
                          </span>  
                        </td>
                      </tr>
                    </tbody>
                </table>

                <table class="table skills back" *ngIf="candidate?.qcm_score?.length > 0">
                    <thead>
                      <tr>
                        <th class="min-w-100px">Score</th>
                        <th></th> <!-- Empty column for alignment -->
                        <th class="min-w-75px">Coeff</th>
                        <th class="min-w-75px">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="candidate?.qcm_score[0]?.scoreQCM != null 
                          && candidate?.qcm_score[0]?.scoreQCM != undefined; else noScore">
                        <tr>
                          <td>
                            <span class="style skill-badge">QCM {{ candidate?.qcm_score[0]?.scoreQCM }}%</span>
                          </td>
                          <td></td>
                          <td>{{ candidate?.qcm_score[0]?.coef }}</td>
                          <td>
                            <span [ngClass]="{
                              'red': candidate?.qcm_score[0]?.user_score >= 0.00 && candidate?.qcm_score[0]?.user_score < 20.00,
                              'light-orange': candidate?.qcm_score[0]?.user_score >= 20.00 && candidate?.qcm_score[0]?.user_score < 40.00,
                              'fancy-orange': candidate?.qcm_score[0]?.user_score >= 40 && candidate?.qcm_score[0]?.user_score < 80.00,
                              'green': candidate?.qcm_score[0]?.user_score >= 80.00
                            }">{{ candidate?.qcm_score[0]?.user_score }}</span>
                          </td>
                        </tr>
                      </ng-container>
                      <!-- Message when qcm_score is not available -->
                      <ng-template #noScore>
                        <tr>
                          <td colspan="4" class="text-danger">{{ candidate?.qcm_score?.message }}</td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
              </div>
        </div>
    </div>
</div>